import { render } from "./control-validator-group.vue?vue&type=template&id=2d069a6f&ts=true"
import script from "./control-validator-group.vue?vue&type=script&lang=ts"
export * from "./control-validator-group.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__